/**
 * Parse date string in dd/mm/yyyy format to Date object
 * @param {string} dateString - Date string in dd/mm/yyyy format
 * @returns {Date|null} - Parsed Date object or null if invalid
 */
export default function parseDateFromDDMMYYYY(dateString) {
  if (!dateString || typeof dateString !== "string") {
    return null;
  }

  const dateRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
  const match = dateString.match(dateRegex);

  if (!match) {
    return null;
  }

  const day = parseInt(match[1], 10);
  const month = parseInt(match[2], 10) - 1;
  const year = parseInt(match[3], 10);

  if (day < 1 || day > 31 || month < 0 || month > 11) {
    return null;
  }

  const date = new Date(year, month, day);

  if (
    date.getDate() !== day ||
    date.getMonth() !== month ||
    date.getFullYear() !== year
  ) {
    return null;
  }

  return date;
}
